<template>
  <div class="user-page-aside">
    <div class="user-page-aside__header">
      <span class="user-page-aside__title"> Навигация </span>
    </div>
    <ul class="user-page-aside__list">
      <li v-for="(page, i) in pages" :key="i">
        <router-link
          :to="page.route"
          :class="{ 'user-page-aside__link--active': JSON.stringify(value) === JSON.stringify(page) }"
          class="user-page-aside__link"
        >
          <span>{{ page.title }}</span>
          <IconComponent name="arrow-right-1" />
        </router-link>
      </li>
      <li>
        <a @click.prevent="logout({ store: $store, router: $router })" class="user-page-aside__link" href="#">
          <span>Выход</span>
          <IconComponent name="arrow-right-1" />
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import IconComponent from "components/IconComponent.vue";
import { logout } from "@/utils";

export default {
  name: "UserPageAsideComponent",
  components: { IconComponent },
  props: {
    pages: Array,
    value: Object,
  },
  methods: { logout },
};
</script>

<style lang="stylus">
.user-page-aside {
  display grid
  border: 1px solid var(--gray)
  border-radius: var(--small_radius)
  +below(860px) {
    display none
  }

  &__header {
    padding 20px
  }

  &__title {
    font-weight: 700;
    font-size: 1.125em
    line-height: 140%;
    color: var(--main-color)
  }

  &__list {
    display grid
  }

  &__link {
    padding 10px 20px
    font-size: 0.875em
    line-height: 145%;
    gap 8px
    display flex
    align-items center
    justify-content space-between
    border-top 1px solid var(--gray)

    .icon {
      width 12px
      height 12px
    }

    &--active {
      color var(--main-color-75)
    }
  }
}
</style>
